module.exports = __webpack_public_path__ + "static/hipsterSizesMB-b469d5b27cebd4dbcdc1418d0a7ac9d8.jpg";